import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreatePrescriptionUrlModel } from './models';
import { CreateQueueUrlModel } from './models';

@Injectable({
  providedIn: 'root'
})
// tslint:disable-next-line:class-name
export class eRxService {
  constructor(private readonly http: HttpClient) { }

  public getPrescriptions(patientId: string): Observable<any> {
    return this.http.get<any>(`api/Rx/${patientId}`);
  }

  public updatePrescription(prescriptionId: string, patientCaseId: string, patientCaseWorkItemId: string): Observable<any> {
    const request = {
      RxId: prescriptionId,
      PatientCaseID: patientCaseId,
      PatientCaseWorkItemID: patientCaseWorkItemId
    };

    return this.http.put<any>(`api/Rx/Prescription/${prescriptionId}`, request);
  }

  public deletePatient(patientId: string): Observable<any> {
    return this.http.delete<any>(`api/Rx/DeletePatientTest/${patientId}`);
  }

  public getPrescriptionUrl(model: CreatePrescriptionUrlModel): Observable<any> {
    return this.http.post<any>(`api/Rx/PrescriptionUrl`, model);
  }

  public refreshPatientPrescription(model: CreatePrescriptionUrlModel): Observable<any> {
    return this.http.post<any>('api/Rx/refresh', model);
  }
  public validatePatient(model: CreatePrescriptionUrlModel): Observable<any> {
    return this.http.post<any>(`api/Rx/ValidatePatientForERX`, model);
  }

  public getReportUrl(model: CreateQueueUrlModel): Observable<any> {
    return this.http.post<any>(`api/Rx/ReportUrl`, model);
  }

  public getQueuedPrescriptions(): Observable<number> {
    return this.http.get<number>(`api/Rx/QueuedPrescriptions/`);
  }
}
